import script from "./Socials.vue?vue&type=script&setup=true&lang=js"
export * from "./Socials.vue?vue&type=script&setup=true&lang=js"

import "./Socials.vue?vue&type=style&index=0&id=600e0fff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-600e0fff"]])

export default __exports__